import withAuth from './../../common/helper/auth-component.js';
import { connect } from 'react-redux';
const Reports = () => { 
    return(
        <div style={{'text-align':'center', 'margin-top':'20%'}}>
        <h2>Coming Soon</h2>
      </div>
    )
}

function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(Reports));